import { Heading } from "@freightsimple/ui-core/Typography/Heading";
import type { Shipment } from "@freightsimple/generated-dashboard-openapi-client/models/Shipment";

interface PickupAddressPageProp {
  shipment: Shipment;
}

export function ModifyShipmentPickupAddressPage(_props: PickupAddressPageProp) {
  return <Heading level={1}>Pickup Address</Heading>;
}
